"use strict";
(() => {
  // src/scripts/components/product-card-swipe.js
  (() => {
    const BREAKPOINT = "(max-width: 989px)";
    const CARD_SELECTOR = ".card__media--swipeable-TWP";
    const initialisedCards = /* @__PURE__ */ new WeakMap();
    const attachDrag = (track) => {
      let isDragging = false;
      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      const onPointerDown = (e) => {
        if (e.pointerType === "touch") return;
        isDragging = true;
        pointerId = e.pointerId;
        startX = e.clientX;
        startScrollLeft = track.scrollLeft;
        track.setPointerCapture(pointerId);
      };
      const onPointerMove = (e) => {
        if (!isDragging || e.pointerId !== pointerId) return;
        track.scrollLeft = startScrollLeft - (e.clientX - startX);
      };
      const endDrag = (e) => {
        if (!isDragging || pointerId !== null && e.pointerId !== pointerId) return;
        isDragging = false;
        if (pointerId !== null && track.hasPointerCapture(pointerId)) {
          track.releasePointerCapture(pointerId);
        }
        pointerId = null;
      };
      track.addEventListener("pointerdown", onPointerDown);
      track.addEventListener("pointermove", onPointerMove);
      track.addEventListener("pointerup", endDrag);
      track.addEventListener("pointercancel", endDrag);
      track.addEventListener("pointerleave", endDrag);
      return () => {
        track.removeEventListener("pointerdown", onPointerDown);
        track.removeEventListener("pointermove", onPointerMove);
        track.removeEventListener("pointerup", endDrag);
        track.removeEventListener("pointercancel", endDrag);
        track.removeEventListener("pointerleave", endDrag);
      };
    };
    const attachTapToProduct = (card) => {
      const url = card.dataset.productUrlTwp;
      if (!url) return () => {
      };
      const onClick = (e) => {
        if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        window.location.href = url;
      };
      card.addEventListener("click", onClick);
      return () => card.removeEventListener("click", onClick);
    };
    const initCard = (card) => {
      if (initialisedCards.has(card)) return;
      const track = card.querySelector(".media.media--hover-effect");
      if (!track) return;
      const slides = track.querySelectorAll("img");
      if (slides.length < 2) return;
      const detachDrag = attachDrag(track);
      const detachTap = attachTapToProduct(card);
      initialisedCards.set(card, { detachDrag, detachTap });
    };
    const teardownCard = (card) => {
      const entry = initialisedCards.get(card);
      if (!entry) return;
      entry.detachDrag();
      entry.detachTap();
      initialisedCards.delete(card);
    };
    const initAll = () => document.querySelectorAll(CARD_SELECTOR).forEach(initCard);
    const teardownAll = () => document.querySelectorAll(CARD_SELECTOR).forEach(teardownCard);
    const mql = window.matchMedia(BREAKPOINT);
    const handleBreakpointChange = (e) => e.matches ? initAll() : teardownAll();
    if (mql.matches) initAll();
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", handleBreakpointChange);
    } else if (typeof mql.addListener === "function") {
      mql.addListener(handleBreakpointChange);
    }
    const grid = document.getElementById("ProductGridContainer");
    if (grid && "MutationObserver" in window) {
      let debounce;
      const mutationObserver = new MutationObserver(() => {
        if (!window.matchMedia(BREAKPOINT).matches) return;
        clearTimeout(debounce);
        debounce = setTimeout(initAll, 150);
      });
      mutationObserver.observe(grid, { childList: true, subtree: true });
    }
  })();
})();
